import { Store } from 'libx'

export default class BillingScreenStore extends Store {}
